var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonepePayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.5C20.4036 25.5 26 19.9036 26 13C26 6.09644 20.4036 0.5 13.5 0.5C6.59644 0.5 1 6.09644 1 13C1 19.9036 6.59644 25.5 13.5 25.5Z",
    fill: "#5F259F",
    stroke: "#EAEAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 10.91C17.86 10.55 17.55 10.24 17.19 10.24H15.96L13.14 6.99998C12.88 6.69998 12.47 6.59998 12.06 6.69998L11.08 7.00998C10.93 7.05998 10.87 7.26998 10.98 7.36998L14.06 10.3H9.39001C9.24001 10.3 9.13 10.4 9.13 10.56V11.07C9.13 11.43 9.44 11.74 9.8 11.74H10.52V14.2C10.52 16.05 11.5 17.13 13.14 17.13C13.65 17.13 14.06 17.08 14.58 16.87V18.51C14.58 18.97 14.94 19.33 15.4 19.33H16.12C16.27 19.33 16.43 19.18 16.43 19.02V11.68H17.61C17.76 11.68 17.87 11.58 17.87 11.42V10.91H17.86ZM14.58 15.33C14.27 15.48 13.86 15.54 13.55 15.54C12.73 15.54 12.32 15.13 12.32 14.2V11.74H14.58V15.33Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepePayment);
export default __webpack_public_path__ + "static/media/phonepe-payment.32eb86051ceaa1b400e98a5db9c6d013.svg";
export { ForwardRef as ReactComponent };